import angular from "angular";

angular
    .module('app')
    .component('individualCourseAutomatizationSettings', {
        template: require('./individual-course-automatization-settings.html'),
        controller: ['$http', 'Notifier', controller],
        bindings: {
            course: '<'
        }
    });

function controller($http, Notifier) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.chapters = $ctrl.course.chapters;
        console.log($ctrl.chapters);
    };

    $ctrl.updateLessonHomeworkRequire = function (lesson) {
        let params = {
            lesson: lesson,
        };
        $http.post(`/admin/courses/${$ctrl.course.id}/individual-training/update-individual-lesson-homework-require`, params).then(
            function (response) {
                Notifier.success('Информация успешно обновлена', 2);
            },

            function (error) {
                Notifier.error('Произошла ошибка', 2);
            });
    };

    $ctrl.updateLessonQuizRequire = function (lesson) {
        let params = {
            lesson: lesson,
        };
        $http.post(`/admin/courses/${$ctrl.course.id}/individual-training/update-individual-lesson-quiz-require`, params).then(
            function (response) {
                Notifier.success('Информация успешно обновлена', 2);
            },
            function (error) {
                Notifier.error('Произошла ошибка', 2);
            });
    };

    $ctrl.updateLessonDelayRequire = function (lesson) {
        let params = {
            lesson: lesson,
        };

        $http.post(`/admin/courses/${$ctrl.course.id}/individual-training/update-individual-lesson-delay-require`, params).then(
            function (response) {
                Notifier.success('Информация успешно обновлена', 2);
            },

            function (error) {
                Notifier.error('Произошла ошибка', 2);
            });
    };

    $ctrl.updateLessonDelayAmount = function (lesson) {
        if (lesson.can_open_delay != null && lesson.can_open_delay >= 0) {
            let params = {
                lesson: lesson,
            };

            $http.post(`/admin/courses/${$ctrl.course.id}/individual-training/update-individual-lesson-delay-amount`, params).then(
                function (response) {
                    Notifier.success('Информация успешно обновлена', 1);
                },

                function (error) {
                    Notifier.error('Произошла ошибка', 2);
                });

        } else {
            Notifier.error('Введите значение большее либо равное нулю',2);
        }
    }
}
